import get from "lodash/get";

export const getStoryData = (story, relatedStories = []) => {
  const {
    metadata = {},
    ["linked-entities"]: linkedEntities = [],
    sections = [],
    ["first-published-at"]: firstPublishedAt = null,
    timezone = null,
  } = story || {};

  const [linkedEntity = null] = linkedEntities;

  const {
    ["desktop-svg"]: desktopSvgs = [],
    name: entityName = "",
  } = linkedEntity || {};

  const [{ url: desktopSvg = "" } = {}] = desktopSvgs;

  const finalRelatedStories = relatedStories;

  const [currentSection = {}] = sections;
  const { name: sectionName = "", slug: sectionSlug = "", ["section-url"]: sectionUrl = "" } = currentSection;

  // Extract path from section-url (handles parent/child hierarchy)
  let fullSectionSlug = sectionSlug;
  if (sectionUrl) {
    try {
      const url = new URL(sectionUrl);
      fullSectionSlug = url.pathname.replace(/^\//, '');
    } catch (e) {
      fullSectionSlug = sectionSlug;
    }
  }

  const { quarter } = metadata;

  return {
    metadata,
    linkedEntity,
    desktopSvg,
    entityName,
    finalRelatedStories,
    sectionName,
    sectionSlug: fullSectionSlug,
    firstPublishedAt,
    quarter,
    timezone,
  };
};
